import PropTypes from 'prop-types'
import cn from 'classnames'
import { createUseStyles } from '../../helpers/createStyles'
import { theme } from '../../styles/theme'
import Section from '../Section'

import useScrollTrigger from '../../hooks/useScrollTrigger'

const HorizontalLine = ({ data: { marginAbove, dark } }) => {
  const styles = useStyles()

  const sectionRef = useScrollTrigger(
    () => ({
      trigger: sectionRef.current,
      start: () => `${window.innerHeight / 4}px bottom`,
      scrub: false
    }),
    (tl, ref) => {
      const defaults = {
        ease: 'power2.inOut',
        duration: 0.8
      }
      tl.from(ref.current.querySelectorAll(`.${styles.line}`), { scaleX: 0, transformOrigin: '0 0', ...defaults })
    }
  )

  return (
    <Section className={cn(styles.root, marginAbove && styles.marginAbove, dark && 'is-dark')} grid ref={sectionRef}>
      <h2 className={styles.line} />
    </Section>
  )
}

const useStyles = createUseStyles({
  root: `
    row-gap: 0;
  `,
  marginAbove: `
    margin-top: ${theme.section.marginBottom.sm}px;
    ${theme.breakpoints.up('md')} {
      margin-top: ${theme.section.marginBottom.md}px;
    }
    ${theme.breakpoints.up('xl')} {
      margin-top: ${theme.section.marginBottom.xl}px;
    }
  `,
  line: `
    height: 1px;
    background: var(--border);
    grid-column: 1 / -1;
    margin: 0;
    .is-dark & {
      background: rgba(0,0,0,0.2);
    }
  `
})

HorizontalLine.propTypes = {
  data: PropTypes.shape({
    marginAbove: PropTypes.boolean,
    dark: PropTypes.boolean
  }).isRequired,
  page: PropTypes.object.isRequired
}

export default HorizontalLine
